/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type { ParametresGeneraux } from '@/types';

const DEFAULT_PARAMETRES_GENERAUX: ParametresGeneraux = {
  identifiantEntite: null,
  identifiantAdresseMairie: null,
  identifiantCiviliteMaire: null,
  nomCommune: '',
  nomMaire: '',
  telephone1: '',
  telephone2: '',
  adresseEmail: '',
  numeroFichierPecoto: 1,
  versionFichierPecoto: 1,
  dernierEnvoiPecoto: '',
  apiHubeeLiaisonActive: false,
  apiHubeeUrl: '',
  apiHubeeVersion: '',
  apiHubeeToken: '',
  apiHubeeLogin: '',
  apiHubeeMdp: '',
  prepose: null,
  imageCachet: '',
  cheminCachet: '',
  imageSignature: '',
  cheminSignature: '',
  adresse: null,
  stockageObjetCachet: '',
  stockageObjetSignature: '',
};

export default DEFAULT_PARAMETRES_GENERAUX;
